import { TreatmentTarget } from "../treatments/treatment_target";

export class TransferTeamTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  validate() {
    let response = {}
    this.querySelectorAll('select').forEach((input) => { 
      input.classList.remove("error")
      if(input.value === "") {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getData() {
    return {value: {assign_to_team_id: this.querySelector('.select-teams').value}, type: TransferTeamTreatment.getType()};
  }

  getIcon() {
    return 'fa-arrow-circle-right'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "TEAM_TRANSFER"
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="col-sm-12 ct_action" data-action_type=transfer_to_team>
        <div class="panel panel-default">
            <h4>Transfer to Team</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="form-group">
              <label>Choose Team</label>
              <select name="teams" is="teams-select" class="select-teams form-control"></select>
            </div>
        </div>
      </div>
      `;
    super.connectedCallback();
    if(this.message) {
      console.log(this.message);
      this.querySelector('select').value =  this.message.message_responses[0].assign_to_team_id || '';
    }
  }
}

customElements.define('transfer-team-treatment', TransferTeamTreatment)